import React from "react";
import { useSiteContent } from "@/context/SiteContentContext";

export function GlobalSiteBanner() {
  const { content } = useSiteContent();
  const b = content.global_banner;
  if (!b?.enabled || !b.text?.trim()) return null;
  const inner = <span>{b.text}</span>;
  return (
    <div
      data-testid="global-site-banner"
      className="sticky top-0 z-[55] bg-electric/90 text-white text-center text-sm py-2 px-4"
    >
      {b.href?.trim() ? (
        <a href={b.href} className="hover:underline font-medium">
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
}
